<template>
  <v-container class="pa-0 d-flex flex-column gap-8">
    <!--  header --->
    <v-container class="pa-0 d-flex justify-space-between">
      <div class="d-flex align-center gap-2">
        <img
          :src="$store.state.userData.avatar?.link || require('@/assets/logo-abr-iron.png')"
          height="30"
          width="30"
          style="border: 1px solid silver;border-radius: 3px;"
        />
        <div>
          <v-card-text
            style="white-space: normal !important;word-break: break-word !important;max-width: 150px;display: block;"
            class="pa-0 text-body-2 text-right"
          >
          {{ $store.state.userData.name }}
          </v-card-text>
          <v-card-text class="pa-0 text-body-2 text-right" style="color: #938888;">
          {{ $store.state.userData.username }}
          </v-card-text>
        </div>
      </div>
      <v-btn
        outlined
        color="error"
        height="30"
        @click="$emit('exit')"
      >
        {{ $t('logout') }}
        <v-icon size="15" class="mr-2">mdi-keyboard-backspace</v-icon>
      </v-btn>
    </v-container>

    <v-container class="pa-0 ma-0">
      <v-card-title class="pa-0 custom-title mb-2">{{ headerTitle }}</v-card-title>
      <v-card-text
        class="pa-0 text-body-2 grey--text text--darken-2"
        v-html="headerSubtitle"
      ></v-card-text>
    </v-container>
    <!--  Business Selector --->
    <v-form class="ma-0 pa-0">
      <!-- list of Business --->
      <v-sheet v-if="business" class="pa-0 d-flex flex-column gap-3 business-list">
        <v-btn
          v-for="item in userData"
          :key="item.id"
          outlined
          :loading="loading"
          color="grey-darken-1"
          style="padding: 7px !important;"
          class="business-item d-flex aling-center justify-center"
          height="auto"
          @click="findBusiness(item)"
        >
        <v-container class="d-flex align-center justify-space-between pa-0">
          <div class="d-flex align-center gap-3">
            <img
              :src="item.logo?.link || require('@/assets/logo-abr-iron.png')"
              height="40"
              width="40"
              style="border: 1px solid silver;border-radius: 3px;"
            />
            <div>
              <v-card-text
                style="white-space: normal !important;word-break: break-word !important;max-width: 150px;display: block;"
                class="pa-0 text-body-1 text-right mb-1"
              >
              {{ item.name ? item.name : '-' }}
              </v-card-text>
               <v-card-text class="pa-0 text-body-2 text-right" style="color: #938888;">
                {{ item.app_key ? item.app_key + '#' : '-' }}
              </v-card-text>
            </div>
          </div>
          <div>
            <v-chip
              v-if="(item.plan_days_left == 0 || item.plan_days_left < 0)"
              color="red"
              small
              style="color: #fff;padding: 0 5px;"
            >
            {{ $t('expired') }}
            </v-chip>
            <v-card-text
              v-else
              class="pa-0 text-body-2 text-right"
              style="color: #938888;"
            >
              <span style="color: black;">{{ item.plan_days_left ? item.plan_days_left : '-' }}</span>
              {{ $t('days-left') }}
            </v-card-text>
          </div>
        </v-container>
        </v-btn>
      </v-sheet>
      <v-btn
        outlined
        color="primary"
        class="mt-3 w-100"
        small
        height="42"
        @click="$router.push('/business-Info')"
      >
        {{ $t("create-new-business") }}
        <v-icon size="20" class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </v-form>
    <!--  footer --->
    <!-- <v-card-text class="pa-0 ma-0 text-center grey--text text--darken-1 text-body-2">
      {{ $t("login terms&condition") }}
      <a href="#" class="primary--text text-decoration-none">
        {{ $t("terms of use") }}
      </a>
      {{ $t("terms of service and policy") }}
      <a href="#" class="primary--text text-decoration-none">
        {{ $t("privacy policy half") }}
      </a>
      {{ $t("abriron is") }}
    </v-card-text> -->

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from '@/Mixins/general'

export default {
  name: 'businessSelector',
  mixins: [General],
  props: {
    userData: Array,
    authToken: String
  },
  data: () => ({
    business: true,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    loading: false
  }),
  computed: {
    headerTitle () {
      if (this.business) return this.$t('select business')
      return ''
    },
    headerSubtitle () {
      if (this.business) return this.$t('witch one business')
      return ''
    }
  },
  methods: {
    findBusiness (val) {
      var app = this
      app.loading = true
      const AuthToken = this.authToken || JSON.parse(localStorage.getItem('primaryToken'))
      this.$axios
        .post(
          this.$apipoint + 'v2/switch-account',
          { id: val.id },
          {
            headers: {
              x_api_key: AuthToken
            }
          }
        )
        .then((response) => {
          app.loading = false
          localStorage.setItem('token', JSON.stringify(response.data.meta))
          localStorage.setItem('fullname', response.data.username)
          app.$axios.defaults.headers.common.Authorization =
            'Bearer ' + response.data.token
          localStorage.setItem('APP_KEY', val.app_key)

          delete app.$axios.defaults.headers.common.x_api_key
          delete app.$axios.defaults.headers.common.domain

          // store js
          app.$store.commit('SET_FULLNAME', response.data.username)
          app.$store.commit(
            'SET_CURRENCY_SYMBOL',
            response.data.meta.init.currencySymbol
          )
          app.$store.commit('SET_FINANCIALYEAR', response.data.meta.init.financialYear)
          app.$store.commit(
            'SET_BACKGROUNDIMAGE',
            response.data.meta.init.backgroundImage
          )
          app.$store.commit(
            'SET_BACKGROUNDCOLOR',
            response.data.meta.init.backgroundColor
          )
          app.$store.commit('SET_START_DATE', response.data.meta.init.startDate)
          app.$store.commit('SET_END_DATE', response.data.meta.init.endDate)
          app.$store.commit('SET_THEME_COLOR', response.data.meta.init.theme_color.value)
          app.$store.commit('SET_DARK', response.data.meta.init.dark.value)
          app.$store.commit('SET_HOVERMENU', response.data.meta.init.hoverMenu.value)
          app.$store.commit(
            'SET_APPBARSOPACITY',
            response.data.meta.init.appBarsOpacity.value
          )
          app.$store.commit('SET_ACCESS', response.data.meta.init.access)
          app.$store.commit('SET_LANG', response.data.meta.init.lang.value)
          app.$store.commit('SET_RTL', response.data.meta.init.rtl.value)
          app.$store.commit('SET_DATE_LOCALE', response.data.meta.init.date_locale.value)
          app.$store.commit(
            'SET_NEGATIVE_INVENTORY',
            response.data.meta.init.negative_inventory.value
          )
          app.$store.commit('SET_CURRENCY', response.data.meta.init.currency)
          app.$store.commit('SET_MENU_BOOKMARK', response.data.meta.init.menuBookmark)
          app.$store.commit('SET_PERMISSIONS', response.data.meta.init.permissions)
          if (response.data.meta.init.teacherAccess) {
            app.$store.commit('SET_TEACHERACCESS', 'active')
            app.$router.push({ name: 'academyDashboard' })
          }
          if (app.shopProp) {
            app.$router.push({ path: 'shop/initialize' })
          }
          localStorage.setItem('apn', null)
          if (val.plan_days_left == 0 || val.plan_days_left < 0) {
            this.$router.push({ name: 'plans' })
          } else {
            app.$router.push('/')
          }
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.overlay = false
          app.loading = false
        })
    }
  }
}
</script>

<style scoped>
.business-list {
  max-height: 245px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.custom-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}
.business-item {
  border: 1.5px solid #e0e0e0 !important;
}
</style>
